import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'


class IntersectionObserverConductor extends PureComponent {

  static childContextTypes = {
    intersectionObserver: PropTypes.shape({
      subscribe: PropTypes.func,
      unsubscribe: PropTypes.func,
    }),
  }

  getChildContext() {
    return {
      intersectionObserver: {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
      },
    }
  }

  subscribers = []

  componentDidMount() {
    this.observer = new window.IntersectionObserver(this.handleIntersection, {})
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  /**
   *
   * @param {Object[]} entries
   * @param {Object} entries[].boundingClientRect
   * @param {number} entries[].intersectionRatio
   * @param {Object} entries[].intersectionRect
   * @param {Boolean} entries[].isIntersecting
   * @param {Object} entries[].rootBounds
   * @param {node} entries[].target
   * @param {number} entries[].time
   */
  handleIntersection = (entries) => {
    entries.forEach((entry) => {
      this.subscribers.some(({ node, handler }) => {
        if (entry.target === node) {
          handler(entry)
          return true
        }
      })
    })
  }

  /**
   *
   * @param {Object} data
   * @param {node} data.node
   * @param {Function} data.handler
   */
  subscribe = (data) => {
    if (this.observer) {
      this.observer.observe(data.node)
    }

    this.subscribers.push(data)
  }

  /**
   *
   * @param {Object} data
   * @param {node} data.node
   * @param {Function} data.handler
   */
  unsubscribe = (data) => {
    if (this.observer) {
      this.observer.unobserve(data.node)
    }

    this.subscribers = this.subscribers.filter((subscriber) => subscriber.handler !== data.handler)
  }

  render() {
    const { children } = this.props

    return children
  }
}


export default IntersectionObserverConductor
